import React, { forwardRef } from 'react';
import ReactSelect, { components, createFilter } from 'react-select';
import propTypes from 'prop-types';
import { customStyles } from './SearchableSelect.styles';
import { grayscaleColor } from '../../utilities/designTokens';

const DropdownIndicator = (props) => {
  const { isDisabled } = props;
  const opacity = isDisabled ? 0.59 : 1;
  const fill = isDisabled ? grayscaleColor['40'] : grayscaleColor['10'];
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.DropdownIndicator {...props}>
      <svg className="cmp-tire-finder__arrow-icon" style={{ opacity }} width="23" height="13" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2559 12.5359L0.231445 5.66773V0.286377L11.2559 7.15503L22.2812 0.303467V5.66773L11.2559 12.5359Z" fill={fill} />
      </svg>
    </components.DropdownIndicator>
  );
};

const SearchableSelect = forwardRef(({
  options,
  id,
  label,
  name,
  placeholder = 'Select...',
  value,
  onChange,
  isDisabled = false,
}, selectRef) => (
  <div className="cmp-form__control-wrapper">
    <label
      htmlFor={id}
      className={`cmp-form__control-label ${isDisabled ? 'cmp-form__control-label--disabled' : ''}`}
      data-testid="searchable-select-label"
    >
      {label}
    </label>
    <ReactSelect
      filterOption={createFilter({ matchFrom: 'start' })}
      value={value}
      options={options}
      styles={customStyles}
      components={{ DropdownIndicator }}
      inputId={id}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      openMenuOnFocus
      isDisabled={isDisabled}
      ref={selectRef}
    />
  </div>
));

DropdownIndicator.propTypes = {
  isDisabled: propTypes.bool,
};

SearchableSelect.propTypes = {
  options: propTypes.arrayOf(propTypes.shape({
    value: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
  })),
  id: propTypes.string,
  label: propTypes.string,
  name: propTypes.string,
  placeholder: propTypes.string,
  value: propTypes.shape({
    value: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
    label: propTypes.oneOfType([
      propTypes.string,
      propTypes.number,
    ]),
  }),
  onChange: propTypes.func,
  isDisabled: propTypes.bool,
};

export default SearchableSelect;
